import React from 'react';
import {useTranslation} from 'react-i18next';
import SMCTextInput from '../../../components/Simple/SMCTextInput';
import SMCModalButtonContainer from '../../../components/core/SMCModal/SMCModalButtonContainer';
import SMCButton from '../../../components/Simple/SMCButton';
import SMCModalBody from '../../../components/core/SMCModal/SMCModalBody';
import SMCLabel from '../../../components/Simple/SMCLabel';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';

function SystemRoleWizardBody({
    onCancel,
    onFinish,
    wizardVars
}) {
    const { t } = useTranslation();
    
    const {
        name, setName,
        description, setDescription,
    } = wizardVars;

    return (
        <>
            <SMCModalBody lineHeight="26px" labelWidth={200}>
                <SMCLabel bold>{t('SMP.SYSTEM_ROLES.NEW_ROLE_WIZ.DEFINE_NEW')}:</SMCLabel>
                {/* Name */}
                <SMCTextInput
                    label={t('SMP.NAME')}
                    value={name}
                    onChange={e => setName(e.target.value)}
                />
                {/* Description */}
                <SMCTextInput
                    value={description}
                    onChange={e => setDescription(e.target.value)}
                    label={t('SMP.DESCRIPTION')}
                />
            </SMCModalBody>
            <SMCModalButtonContainer>
                <SMCButton onClick={onFinish} style={{ marginRight: 5 }}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="green" icon="check" />
                    {t('SMC_GEN_FINISH')}
                </SMCButton>
                <SMCButton onClick={onCancel}>
                    <FontAwesomeIcon style={{ marginTop: '3px', marginRight: '5px' }} color="grey" icon="times" />
                    {t('SMC_GEN_CANCEL')}
                </SMCButton>
            </SMCModalButtonContainer>
        </>
    );
}

export default SystemRoleWizardBody;